/**
 * Prilagođena konfiguracija @belit/accessibility-panel za OGP.
 * Menjaj ovde boje, font, storageKey i labele — ne diraj core/defaultConfig.js u paketu.
 */

/** Tema (boje, font) za OGP accessibility panel. */
export const CUSTOM_THEME = {
  primary: '#253965',
  primaryHover: '#1e2e52',
  textMuted: '#6b7a94',
  fontFamily: "'Montserrat', system-ui, -apple-system, sans-serif",
};

/** Lokalizovane labele za accessibility panel kontrole. */
export const CUSTOM_LABELS = {
  panelTitle: 'Подешавања приказа',
  openPanel: 'Отвори подешавања приказа',
  closePanel: 'Затвори подешавања приказа',
  close: 'Затвори',
  decrease: 'Смањи',
  increase: 'Повећај',
  toggleOff: 'ИСКЉ',
  toggleOn: 'УКЉ',
  reset: 'Ресетуј на подразумевано',
  resetTitle: 'Ресетуј подешавања',
  tocNav: 'Садржај странице',
  tocToggle: 'Садржај',
  textSizeTitle: 'Величина текста',
  textSizeDesc: 'Подесите величину текста',
  lineSpacingTitle: 'Размак редова',
  lineSpacingDesc: 'Подесите размак између редова текста',
  fontTitle: 'Стил текста',
  fontDesc: 'Промените фонт',
  contrastTitle: 'Контраст',
  contrastDesc: 'Промените боје текста и позадине',
  tocTitle: 'Садржај',
  tocDesc: 'Направите садржај од наслова на страници',
  enhanceTitle: 'Истицање контрола',
  enhanceDesc: 'Истакните везе, дугмад, и поља за унос',
};

/** Prosleđuje se kao config prop u AccessibilityPanel. */
export const CUSTOM_CONFIG = {
  storageKey: 'ogp-a11y-prefs',
  mainContentSelector: '#main-content',
  theme: CUSTOM_THEME,
  labels: CUSTOM_LABELS,
};
